import styled from "styled-components";

export const Main = styled.main`
  @media (min-width: 996px) {
    padding-top: 62px;
  }
`;
